import uniqueId from 'lodash/uniqueId';

import {PLACEHOLDER_ID} from './create-empty-sequence-template';
import type {EmailSequenceTemplate} from './email-template-designer-modal';

export type SuggestedTemplate = {
    name: string;
    description: string;
    hasFollowups: boolean;
    emailSequenceTemplate: EmailSequenceTemplate;
};

let companyName = '[YOUR COMPANY NAME]';

// @ts-expect-error
if (typeof window.NutClientConfig !== 'undefined' && window.NutClientConfig.instanceName) {
    companyName = NutClientConfig.instanceName;
}

export const SuggestedTemplates: SuggestedTemplate[] = [
    {
        name: 'Event follow-up',
        description:
            'So you met a few prospects at an event — you want to re-introduce yourself and continue the conversation.',
        hasFollowups: false,
        emailSequenceTemplate: {
            __typename: 'EmailSequenceTemplate',
            id: PLACEHOLDER_ID,
            name: 'Event follow-up',
            isShared: true,
            group: null,
            isImmutable: false,
            isArchived: false,
            emailAutomation: null,
            lastSentTime: null,
            deletedTime: null,
            canEdit: true,
            creatorUser: {
                __typename: 'User',
                id: '',
                name: '',
                isEnabled: true,
            },
            parent: null,
            children: {__typename: 'EmailSequenceTemplatesConnection', totalCount: 0, edges: []},
            // Kinda hacky, but this will work because the base sequence
            // template has the placeholder id
            userChildSequenceTemplate: null,
            emailSequenceTemplateMessages: [
                {
                    __typename: 'EmailSequenceTemplateMessage',
                    id: uniqueId(),
                    position: 1,
                    sendDelay: {
                        __typename: 'EmailSequenceEmailTemplateSendDelay',
                        delayTimespan: 0,
                    },
                    sendAsReply: false,
                    useSignature: true,
                    emailTemplate: {
                        __typename: 'EmailTemplate',
                        id: uniqueId(),
                        subject: 'Great meeting you at the event! I have something for you...',
                        sentCount: 0,
                        clickCount: 0,
                        openedCount: 0,
                        plaintextBody: `Hi {firstName}, It was a pleasure meeting you the other day. I checked out your company’s website and it sounds like you’re doing amazing things. As I mentioned, I work for a leading provider called ${companyName} that helps companies like yours [specific benefit of your product or service]. If you’re interested, here’s an article that we put together that explains what we do in more detail: [URL of content] I’d be happy to connect on the phone at your convenience if you’d like more information or want to have a more in-depth conversation. Thanks for your time, and have a great day!`,
                        body: `<div>Hi {firstName},</div><div><br></div><div>It was a pleasure meeting you the other day. I checked out your company’s website and it sounds like you’re doing amazing things.</div><div><br></div><div>As I mentioned, I work for a leading provider called ${companyName} that helps companies like yours <span class="NUT-custom-placeholder" id="write something about the recipient’s industry">write something about the recipient’s industry</span>. If you’re interested, here’s an article that we put together that explains what we do in more detail:</div><div><br></div><div><strong>[URL of content]</strong></div><div><br></div><div>I’d be happy to connect on the phone at your convenience if you’d like more information or want to have a more in-depth conversation. Thanks for your time, and have a great day!</div>`,
                    },
                },
            ],
        },
    },

    {
        name: 'Proposal check-in',
        description:
            'Just because you’ve sent a proposal doesn’t mean the deal is done. Here’s how you might move things along, without badgering.',
        hasFollowups: false,
        emailSequenceTemplate: {
            __typename: 'EmailSequenceTemplate',
            id: PLACEHOLDER_ID,
            name: 'Proposal check-in',
            isShared: true,
            group: null,
            isImmutable: false,
            isArchived: false,
            emailAutomation: null,
            creatorUser: {
                __typename: 'User',
                id: '',
                name: '',
                isEnabled: true,
            },
            lastSentTime: null,
            deletedTime: null,
            canEdit: true,
            parent: null,
            children: {__typename: 'EmailSequenceTemplatesConnection', totalCount: 0, edges: []},
            // Kinda hacky, but this will work because the base sequence
            // template has the placeholder id
            userChildSequenceTemplate: null,
            emailSequenceTemplateMessages: [
                {
                    __typename: 'EmailSequenceTemplateMessage',
                    id: uniqueId(),
                    position: 1,
                    sendDelay: {
                        __typename: 'EmailSequenceEmailTemplateSendDelay',
                        delayTimespan: 0,
                    },
                    sendAsReply: false,
                    useSignature: true,
                    emailTemplate: {
                        __typename: 'EmailTemplate',
                        id: uniqueId(),
                        subject: 'Any questions on the proposal, {firstName}?',
                        sentCount: 0,
                        clickCount: 0,
                        openedCount: 0,
                        plaintextBody:
                            'Hi {firstName}, How are you? Have you had a chance to look over the proposal I sent over? I’d be happy to go over it with you on the phone and answer any questions you still have. Got any time early next week? No worries if you and your team are still reviewing the proposal—I know how busy things can get this time of year, and I just wanted to make sure it didn’t fall off your radar. Have a great day, and we’ll talk soon!',
                        body: '<div>Hi {firstName},</div><div><br></div><div>How are you? Have you had a chance to look over the proposal I sent over? I’d be happy to go over it with you on the phone and answer any questions you still have. Got any time early next week?</div><div><br></div><div>No worries if you and your team are still reviewing the proposal—I know how busy things can get this time of year, and I just wanted to make sure it didn’t fall off your radar.</div><div><br></div><div>Have a great day, and we’ll talk soon!</div>',
                    },
                },
            ],
        },
    },
    {
        name: 'The quick time saver',
        description:
            'This is a message with a note focused on saving time to capture the attention of your leads. It includes two automated follow-ups, if your leads don’t get back to you at first.',
        hasFollowups: true,
        emailSequenceTemplate: {
            __typename: 'EmailSequenceTemplate',
            id: PLACEHOLDER_ID,
            name: 'The quick time saver',
            isShared: true,
            group: null,
            isImmutable: false,
            isArchived: false,
            emailAutomation: null,
            creatorUser: {
                __typename: 'User',
                id: '',
                name: '',
                isEnabled: true,
            },
            lastSentTime: null,
            deletedTime: null,
            canEdit: true,
            parent: null,
            children: {__typename: 'EmailSequenceTemplatesConnection', totalCount: 0, edges: []},
            // Kinda hacky, but this will work because the base sequence
            // template has the placeholder id
            userChildSequenceTemplate: null,
            emailSequenceTemplateMessages: [
                {
                    __typename: 'EmailSequenceTemplateMessage',
                    id: uniqueId(),
                    position: 1,
                    sendDelay: {
                        __typename: 'EmailSequenceEmailTemplateSendDelay',
                        delayTimespan: 0,
                    },
                    sendAsReply: false,
                    useSignature: true,
                    emailTemplate: {
                        __typename: 'EmailTemplate',
                        id: uniqueId(),
                        subject: `{firstName} + ${companyName} = ???`,
                        sentCount: 0,
                        clickCount: 0,
                        openedCount: 0,
                        plaintextBody: `Hi {firstName}, I know your time is valuable, so I’ll keep this brief. My company, ${companyName}, specializes in saving time for businesses that are struggling with …. I know what you’re thinking… And that’s fine. But there’s a reason why we’ve been so successful at building a community of thrilled customers. Are you available to connect on the phone for 15 minutes? I’d love to see if we can help you out!`,
                        body: `<div>Hi {firstName},</div><div><br></div><div>I know your time is valuable, so I’ll keep this brief.</div><div><br></div><div>My company, ${companyName}, specializes in saving time for businesses that are struggling with <span class="NUT-custom-placeholder" id="describe the problem that their specific company is likely encountering">describe the problem that their specific company is likely encountering</span>.</div><div><br></div><div>I know what you’re thinking…</div><div><br></div><div><br></div><div>And that’s fine. But there’s a reason why we’ve been so successful at building a community of thrilled customers.</div><div><br></div><div>Are you available to connect on the phone for 15 minutes? I’d love to see if we can help you out in any way!</div><div><br></div>`,
                    },
                },
                {
                    __typename: 'EmailSequenceTemplateMessage',
                    id: uniqueId(),
                    position: 2,
                    sendDelay: {
                        __typename: 'EmailSequenceEmailTemplateSendDelay',
                        delayTimespan: 3,
                    },
                    sendAsReply: true,
                    useSignature: true,
                    emailTemplate: {
                        __typename: 'EmailTemplate',
                        id: uniqueId(),
                        subject: '',
                        sentCount: 0,
                        clickCount: 0,
                        openedCount: 0,
                        plaintextBody:
                            'Hi {firstName}, Did you see the email I sent you a few days ago? If your team could use some help, just drop me a note, and I’ll make the time work. I’m always happy to shoot the breeze about how our company is helping businesses grow.',
                        body: '<div>Hi {firstName},</div><div><br></div><div>Did you see the email I sent you a few days ago? If your team could use some help, just drop me a note, and I’ll make the time work.</div><div><br></div><div>I’m always happy to shoot the breeze about how our company is helping businesses grow.</div><div><br></div>',
                    },
                },
                {
                    __typename: 'EmailSequenceTemplateMessage',
                    id: uniqueId(),
                    position: 3,
                    sendDelay: {
                        __typename: 'EmailSequenceEmailTemplateSendDelay',
                        delayTimespan: 3,
                    },
                    sendAsReply: true,
                    useSignature: true,
                    emailTemplate: {
                        __typename: 'EmailTemplate',
                        id: uniqueId(),
                        subject: '',
                        sentCount: 0,
                        clickCount: 0,
                        openedCount: 0,
                        plaintextBody:
                            'Hi {firstName}, It sounds like there might not be a fit here, at least for now. I’m going to take you off my contact list, but please let me know if I can be of any help in the future. I’d be happy to answer any questions whenever they arise.',
                        body: '<div>Hi {firstName},</div><div><br></div><div>It sounds like there might not be a fit here, at least for now.</div><div><br></div><div>I’m going to take you off my contact list, but please let me know if I can be of any help in the future. I’d be happy to answer any questions whenever they arise.</div><div><br></div>',
                    },
                },
            ],
        },
    },
    {
        name: 'The thoughtful question',
        description:
            'Asking a prospect about their business is a great way to start a conversation. If they miss it, ask it more directly in an automated follow-up.',
        hasFollowups: true,
        emailSequenceTemplate: {
            __typename: 'EmailSequenceTemplate',
            id: PLACEHOLDER_ID,
            name: 'The thoughtful question',
            isShared: true,
            group: null,
            isImmutable: false,
            isArchived: false,
            emailAutomation: null,
            creatorUser: {
                __typename: 'User',
                id: '',
                name: '',
                isEnabled: true,
            },
            parent: null,
            lastSentTime: null,
            deletedTime: null,
            canEdit: true,
            children: {__typename: 'EmailSequenceTemplatesConnection', totalCount: 0, edges: []},
            // Kinda hacky, but this will work because the base sequence
            // template has the placeholder id
            userChildSequenceTemplate: null,
            emailSequenceTemplateMessages: [
                {
                    __typename: 'EmailSequenceTemplateMessage',
                    id: uniqueId(),
                    position: 1,
                    sendDelay: {
                        __typename: 'EmailSequenceEmailTemplateSendDelay',
                        delayTimespan: 0,
                    },
                    sendAsReply: false,
                    useSignature: true,
                    emailTemplate: {
                        __typename: 'EmailTemplate',
                        id: uniqueId(),
                        subject: 'Quick question…',
                        sentCount: 0,
                        clickCount: 0,
                        openedCount: 0,
                        plaintextBody:
                            'Hi {firstName}, I found you while doing some research on [target industry] companies and I was wondering if you could answer this question in one sentence or less: What’s the biggest difference between you and [recipient’s primary competitor]? Thanks in advance! To give some context: I work for a [product/service type] provider that has helped companies like [name of notable client] and [name of notable client] improve their bottom lines by [brief summary of your product or service’s primary benefits]. You can learn more about what we do here: [URL of website tour page, ebook, video, or other resource]',
                        body: '<div>Hi {firstName},</div><div><br></div><div>I found you while doing some research on <span class="NUT-custom-placeholder" id="recipient’s industry">recipient’s industry</span> companies and I was wondering if you could answer this question in one sentence or less: <div><br></div><strong>What’s the biggest difference between you and <span class="NUT-custom-placeholder" id="recipient’s primary competitor">recipient’s primary competitor</span>?</strong></div><div><br></div><div>Thanks in advance! To give some context: I work for a business that has helped companies like <span class="NUT-custom-placeholder" id="name of a relevant, notable client">name of a relevant, notable client</span> improve their bottom lines. You can learn more about what we do here: <strong>URL of website tour page, video, or other resource</strong></div>',
                    },
                },
                {
                    __typename: 'EmailSequenceTemplateMessage',
                    id: uniqueId(),
                    position: 2,
                    sendDelay: {
                        __typename: 'EmailSequenceEmailTemplateSendDelay',
                        delayTimespan: 3,
                    },
                    sendAsReply: false,
                    useSignature: true,
                    emailTemplate: {
                        __typename: 'EmailTemplate',
                        id: uniqueId(),
                        subject: 'Re: Quick question…',
                        sentCount: 0,
                        clickCount: 0,
                        openedCount: 0,
                        plaintextBody:
                            'Hi {firstName}, I wanted to follow up on the question I sent you a few days ago. Your insights would be hugely appreciated. Based on what I’ve seen from your website and press coverage, the [recipient’s company name] team is doing some amazing things. BUT...during the course of my research I also spotted two things that could be improved when it comes to your [aspect of recipient’s business that your product or service could help with]. Are you available for a brief conversation tomorrow afternoon?',
                        body: '<div>Hi {firstName},</div><div><br></div><div>I wanted to follow up on the question I sent you a few days ago. Your insights would be hugely appreciated.</div><div><br></div><div>Based on what I’ve seen from your website and press coverage, the <span class="NUT-custom-placeholder" id="recipient’s company name">recipient’s company name</span> team is doing some amazing things. BUT...during the course of my research I also spotted two things that could be improved when it comes to your <span class="NUT-custom-placeholder" id="aspect of recipient’s business that your service could help with">aspect of recipient’s business that your service could help with</span>.</div><div><br></div><div>Are you available for a brief conversation tomorrow afternoon?</div><div><br></div>',
                    },
                },
                {
                    __typename: 'EmailSequenceTemplateMessage',
                    id: uniqueId(),
                    position: 3,
                    sendDelay: {
                        __typename: 'EmailSequenceEmailTemplateSendDelay',
                        delayTimespan: 3,
                    },
                    sendAsReply: true,
                    useSignature: true,
                    emailTemplate: {
                        __typename: 'EmailTemplate',
                        id: uniqueId(),
                        subject: '',
                        sentCount: 0,
                        clickCount: 0,
                        openedCount: 0,
                        plaintextBody:
                            'Hi {firstName}, Since I never got an answer from you, I have to assume you’re either insanely busy or just not interested at this time. Is there someone else who might be a better person to connect with about [challenge that your product or service helps with]? I’m going to take you off my contact list, but please let me know if I can be of any help in the future. I’d be happy to answer any questions about [your product/service type] whenever they arise.',
                        body: '<div>Hi {firstName},</div><div><br></div><div>Since I never got an answer from you, I have to assume you’re either insanely busy or just not interested at this time. Is there someone else who might be a better person to connect with?</div><div><br></div><div>I’m going to take you off my contact list, but please let me know if I can be of any help in the future. I’d be happy to answer any questions whenever they arise.</div><div><br></div>',
                    },
                },
            ],
        },
    },
];
